import { BindWalletCallbackUsecase } from '../../../usecase/fs-wallet-account/bind-wallet-callback-usecase';
import { BindWalletUsecase } from '../../../usecase/fs-wallet-account/bind-wallet-usecase';
import { PinCallbackUsecase } from '../../../usecase/fs-wallet-account/pin-callback-usecase';
import { RequestWalletOtpUsecase } from '../../../usecase/fs-wallet-account/request-wallet-otp.usecase';
import { ValidateWalletOtpUsecase } from '../../../usecase/fs-wallet-account/validate-wallet-otp.usecase';

export const walletAccountUsecaseProvider = [
  ValidateWalletOtpUsecase,
  RequestWalletOtpUsecase,
  PinCallbackUsecase,
  BindWalletUsecase,
  BindWalletCallbackUsecase
];
